import React from "react";
import styles from "./WithoutValidEmailModal.module.css"; // Optional CSS module

interface EmailWarningContentProps {
  onSubmit: () => void;
  onCancel: () => void;
}

const WithoutValidEmailModal: React.FC<EmailWarningContentProps> = ({
  onSubmit,
  onCancel,
}) => {
  return (
    <div className={styles.contentWrapper}>
      <h2 className={styles.title}>Information</h2>
      <p className={styles.message}>
        Without any valid email address in the system, this proforma will not be
        linked to your client. You may need to run it again in the future.
      </p>
      <div className={styles.actions}>
        <button className={styles.cancelButton} onClick={onCancel}>
          Cancel
        </button>
        <button className={styles.submitButton} onClick={onSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default WithoutValidEmailModal;
